/**
 * DocumentEntry — client view of a "PDF document" Client Hub entry (docs/CLIENT_HUB_PDF_DOCUMENTS.md):
 * one whole PDF sent as it is, the way a sketch ribbon sends drawings. A book shaped like the
 * document opens it in PdfPageViewer (page by page, shown as each page is drawn, so a heavy deck
 * opens in seconds); Download PDF hands over the file. Reads entry.data.pdf
 * ({ url, name, pages, aspect }); the client only sees it once the entry is published.
 */

import { useState } from 'react'
import Markdown from '../../components/Markdown.jsx'
import { J } from '../journeyUI.jsx'
import JourneyBook from './JourneyBook.jsx'
import PdfPageViewer from '../../components/PdfPageViewer.jsx'

// Supabase serves a public file as an attachment when asked; a plain cross-site link would only
// open it in the browser's own viewer.
function downloadHref(pdf) {
  if (!pdf || !pdf.url) return null
  return pdf.url + (pdf.url.includes('?') ? '&' : '?') + 'download=' + encodeURIComponent(pdf.name || 'document.pdf')
}

export default function DocumentEntry({ entry }) {
  const [open, setOpen] = useState(false)
  const pdf = (entry.data && entry.data.pdf) || null
  const title = entry.title || (pdf && pdf.name ? pdf.name.replace(/\.pdf$/i, '') : 'Document')
  const aspect = pdf && pdf.aspect ? pdf.aspect : 8.5 / 11
  return (
    <div>
      <div style={{ textAlign: 'center', paddingTop: 10 }}>
        <div style={{ ...J.eyebrow, marginBottom: 18 }}>Document</div>
        <h2 style={{ ...J.title, maxWidth: 440, margin: '0 auto' }}>{title}</h2>
        <div style={{ width: 36, height: 1, background: 'rgba(7,39,45,0.24)', margin: '26px auto 30px' }} />
      </div>
      {entry.data?.intro && (
        <div style={{ ...J.body, marginBottom: 26, textAlign: 'center', maxWidth: 420, marginLeft: 'auto', marginRight: 'auto' }}><Markdown text={entry.data.intro} /></div>
      )}
      {pdf && pdf.url ? (
        <>
          <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 6px' }}>
            <JourneyBook label="Document" aspect={aspect} pageCount={pdf.pages || null} onOpen={() => setOpen(true)} downloadUrl={downloadHref(pdf)} />
          </div>
          {open && <PdfPageViewer pdfUrl={pdf.url} images={pdf.images} title={title} downloadUrl={downloadHref(pdf)} onClose={() => setOpen(false)} />}
        </>
      ) : (
        <div style={{ ...J.body, fontStyle: 'italic', color: '#8ba6b1', textAlign: 'center', padding: '18px 0 8px' }}>
          This document is being prepared.
        </div>
      )}
    </div>
  )
}
